import { render, staticRenderFns } from "./hotelItem.vue?vue&type=template&id=49943826&scoped=true"
import script from "./hotelItem.vue?vue&type=script&lang=js"
export * from "./hotelItem.vue?vue&type=script&lang=js"
import style0 from "./hotelItem.vue?vue&type=style&index=0&id=49943826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49943826",
  null
  
)

export default component.exports